import { listVal, nbVal, strValOrUndef } from "@paroi/data-formatters-lib";

export interface Statistics {
  kpis: KpiStat[];
  diagramData?: Map<string, number>;
}

export interface KpiStat {
  tableId: number;
  name?: string;
  property?: string;
  value?: string;
  data: {
    count: number;
    updatedAt?: string;
  };
}

export function formatToStatistics(data: any): Statistics {
  let diagramData: Map<string, number> | undefined;
  if (data.histogram_data && typeof data.histogram_data === "object") {
    for (const [key, val] of Object.entries(data.histogram_data)) {
      if (!diagramData) diagramData = new Map();
      diagramData.set(key, nbVal(val));
    }
  }
  return {
    kpis: listVal(data.kpis, formatToKpiStat),
    diagramData,
  };
}

function formatToKpiStat(data: any): KpiStat {
  return {
    tableId: nbVal(data.table_id),
    name: strValOrUndef(data.name),
    property: strValOrUndef(data.porperty),
    value: strValOrUndef(data.value),
    data: {
      count: nbVal(data.data.count),
      updatedAt: strValOrUndef(data.data.updated_at),
    },
  };
}
